// extracted by mini-css-extract-plugin
module.exports = {"loaderSpinner":"src-js-sign-components-loader-spinner-loader-spinner-module__loaderSpinner--3reWf"};